import { render, staticRenderFns } from "./EmbroideryStrabane.vue?vue&type=template&id=fba5c436"
import script from "./EmbroideryStrabane.vue?vue&type=script&lang=js"
export * from "./EmbroideryStrabane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports